import React, { Component, Fragment } from "react";
import { UNIDADES_ATIVAS } from "../../../../../constants/unidades";

export default class Select extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                    <form>
                        <div className="form-group">
                            <label>Unidade: </label>
                            <select name="select" onChange={this.props.selectUnidade} className="form-control" id={this.props.idComponente || "selectUnidade"}>
                                <option value="Todas">DR</option>
                                {UNIDADES_ATIVAS.map((u) => <option key={u.sigla} value={u.nome}>{u.labelRelatorio}</option>)}
                            </select>
                        </div>
                    </form>
            </Fragment>
        )
    }
}